module.exports = __webpack_public_path__ + "img/page-not-found.05847137.jpg";